import en from './en'
import ptBR from './pt-BR'

export default {
  en,
  'pt-BR': ptBR
}
